module.exports = __webpack_public_path__ + "static/img/connectStart_xiaofang.28be7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/connectStart_xiaofang.png
// module id = 758
// module chunks = 1